<template>
  <el-form
    ref="ruleForm"
    :model="formData"
    label-width="0"
    label-position="top"
    class="error-form"
    size="mini"
  >

    <el-table :data="formData.arr" border>
      <!-- 费用类型 -->
      <el-table-column min-width="120">
        <template #header>
          <div>
            <span style="color: red;">*</span>
            <span>{{ $t('basicData.ExpenseType') }}</span>
          </div>
        </template>
        <template v-slot="scope">
          <el-form-item
            :prop="`arr.${scope.$index}.feeTypeCode`"
            :rules="rules.feeTypeCode"
          >
            <el-select
              v-model="scope.row.feeTypeCode"
              :placeholder="$t('basicData.PleaseSelect')"
              style="width: 100%;"
            >
              <el-option
                v-for="item in feeList"
                :key="item.id"
                :label="item.displayName + '(' + item.code + ')'"
                :value="item.code"
              />
              <!--              :disabled="isFeeTypeDisabled(item.code, scope.row.feeTypeCode, scope.$index)"-->
            </el-select>
          </el-form-item>
        </template>
      </el-table-column>
      <!--货量开始（票）(不包含)-->
      <el-table-column :label="$t('basicData.QuantityStartTicketNotIncluded')" min-width="180">
        <template #header>
          <div>
            <span style="color: red;">*</span>
            <span>{{ $t('basicData.QuantityStartTicketNotIncluded') }}</span>
          </div>
        </template>
        <template v-slot="scope">
          <el-form-item
            :prop="`arr.${scope.$index}.startOfGoodsQuantity`"
            :rules="{
              required: true,
              suffix: '2',
              negative: '',
              negative1: 1,
              package: scope.row.endOfGoodsQuantity,
              validator: Integer0,
              trigger: ['blur', 'change']
            }"
          >
            <el-input v-model="scope.row.startOfGoodsQuantity" />
          </el-form-item>
        </template>
      </el-table-column>
      <!--货量结束（票）(包含)-->
      <el-table-column :label="$t('basicData.EndOfVolumeTicketIncluded')" min-width="180">
        <template #header>
          <div>
            <span style="color: red;">*</span>
            <span>{{ $t('basicData.EndOfVolumeTicketIncluded') }}</span>
          </div>
        </template>
        <template v-slot="scope">
          <el-form-item
            :prop="`arr.${scope.$index}.endOfGoodsQuantity`"
            :rules="{
              required: true,
              suffix: '2',
              negative: '',
              negative1: 2,
              package: scope.row.startOfGoodsQuantity,
              validator: Integer0,
              trigger: ['blur', 'change']
            }"
          >
            <el-input v-model="scope.row.endOfGoodsQuantity" />
          </el-form-item>
        </template>
      </el-table-column>
      <!-- 价格/票-->
      <el-table-column :label="$t('basicData.PricePerTicket')" min-width="180">
        <template #header>
          <div>
            <span style="color: red;">*</span>
            <span>{{ $t('basicData.PricePerTicket') }}</span>
          </div>
        </template>
        <template v-slot="scope">
          <el-form-item
            :prop="`arr.${scope.$index}.price`"
            :rules="{ required: true, suffix: 2, negative: '', negative2: 9, validator: priceType, trigger: ['blur', 'change'] }"
          >
            <el-input v-model="scope.row.price" />
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column :label="$t('basicData.operate')" width="120">
        <template slot-scope="scope">
          <el-button
            size="small"
            type="danger"
            @click="handleDel(scope.$index)"
          >{{ $t('basicData.Delete') }}</el-button>
        </template>
      </el-table-column>
    </el-table>
  </el-form>
</template>

<script>
import { priceType, Integer0 } from '../utils';
export default {
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    // 费用类型
    feeList: {
      type: Array,
      default: () => [],
      required: true
    }
  },

  data() {
    return {
      priceType,
      Integer0,
      formData: {
        arr: []
      },
      rules: {
        feeTypeCode: [
          { required: true, message: this.$t('customerManagements.pleaseChoose'), trigger: ['change', 'blur'] }
        ]
      }
    };
  },

  watch: {
    tableData: {
      handler(val, oldVal) {
        console.log(val, oldVal, 'MDD-table');
        if (oldVal === undefined) {
          // 第一次赋值
          this.formData.arr = [];
          return;
        }

        if (val.length === 0 && oldVal.length === 0) {
          return;
        }

        // 新的值与旧的值一样
        if (JSON.stringify(val) === JSON.stringify(this.formData.arr)) {
          return;
        }
        this.formData.arr = val;
      },
      immediate: true
    },

    // 将数据传给父组件
    formData: {
      handler(val, oldVal) {
        if (!oldVal || !val) {
          return;
        }
        this.$emit('change', val.arr);
      },
      deep: true
      // immediate: true
    }
  },
  methods: {
    // 提交校验
    submitForm() {
      return this.$refs['ruleForm'].validate().then(() => {
        return true;
      }).catch(() => {
        return false;
      });
    },

    // 删除
    handleDel(index) {
      console.log(index);
      this.formData.arr.splice(index, 1);
    }

    // 判断费用类型是否禁用
    // isFeeTypeDisabled(itemCode, currentRowCode, currentIndex) {
    //   // 当前行已选中的不禁用
    //   if (itemCode === currentRowCode) {
    //     return false;
    //   }
    //
    //   // 检查其他行是否已选择该费用类型
    //   return this.formData.arr.some((row, index) =>
    //     index !== currentIndex && row.feeTypeCode === itemCode
    //   );
    // }
  }
};
</script>
